import React from 'react';
import {Link} from "react-router-dom";
import {PageWrapper} from "../../../../components/UI/PageWrapper/PageWrapper";
import styled from "styled-components";
import {ProfileUser} from "./components/ProfileUser/ProfileUser";
import {ProfileCompany} from "./components/ProfileCompany/ProfileCompany";
import {ProfilePersonnel} from "./components/ProfilePersonnel/ProfilePersonnel";
import {useAppSelector, useAppDispatch} from "../../../../store/store";
import {groupUserAdmin} from "../../../../config/acl/roles/groups";
import {mediaScreenSizes} from "../../../../utils/constans/styles/screenSizes";
import {pathFromRoute} from "../../../../utils/helpers/acl/pathFromRoute";
import {Route} from "../../../../config/acl/routes/Route";
import {FormattedMessage} from "react-intl";
import {RightOutlined, LogoutOutlined} from "@ant-design/icons";
import {logout} from "../../../../store/reducers/authReducer/authReducer";

const CompanyAndUserWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  width: 95%;

  @media(max-width: ${mediaScreenSizes.tablet}) {
    width: 100%;
    flex-direction: row;
    column-gap: 16px;
  }
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    width: 100%;
    flex-direction: column;
    row-gap: 16px;
  }
`;

const ProfileLinksSection = styled.section`
  margin-top: 24px;
  width: 95%;
  @media(max-width: ${mediaScreenSizes.mobile}) {
    width: 100%;
  }
`;

const ProfileLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  margin-bottom: 8px;
  border-radius: 8px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  color: inherit;
  text-decoration: none;
  font-weight: 500;
  transition: background 0.2s;
  &:hover {
    background: #f5f5f5;
    color: inherit;
  }
  .anticon {
    color: rgba(0, 0, 0, 0.45);
  }
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  margin-top: 16px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #ffccc7;
  color: #cf1322;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
  .anticon {
    color: #cf1322;
  }
  &:hover {
    background: #fff2f0;
    border-color: #ffa39e;
  }
`;

export const ProfilePage = () => {
  const {role} = useAppSelector(state => state.user.oneItemObject.item);
  const dispatch = useAppDispatch();

  return (
    <PageWrapper>
      <CompanyAndUserWrapper>
        <ProfileCompany />
        <ProfileUser />
      </CompanyAndUserWrapper>
      {groupUserAdmin.includes(role) && <ProfilePersonnel />}
      <ProfileLinksSection>
        <ProfileLink to={pathFromRoute(Route.messageTemplates)}>
          <FormattedMessage id="messageTemplatesRoute.title" defaultMessage="Message Templates" />
          <RightOutlined />
        </ProfileLink>
        <ProfileLink to={pathFromRoute(Route.subscription)}>
          <FormattedMessage id="subscriptionRoute.title" defaultMessage="Subscription" />
          <RightOutlined />
        </ProfileLink>
        <LogoutButton type="button" onClick={() => dispatch(logout())}>
          <FormattedMessage id="logout.title" defaultMessage="Log out" />
          <LogoutOutlined />
        </LogoutButton>
      </ProfileLinksSection>
    </PageWrapper>
  );
};

